module.exports = __webpack_public_path__ + "img/logo.10b1d53d.png";